import { AppShell } from "./forge/components/AppShell";

export function App() {
  return <AppShell />;
}
